import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion"
import Link from "next/link"
import { HeaderNavMenuTypes } from "@/Types/GlobalTypes"
import { useState } from "react"
import { HeaderNavbarFetchedData } from "@/Types/FetchedDataTypes"
interface ComponentProps {
  navMenu: HeaderNavbarFetchedData[]
}

export default function ResponsiveNavMenu({ navMenu }: ComponentProps) {

  const [headerMenu, setHeaderMenu] = useState<[] | HeaderNavbarFetchedData[]>(navMenu ? navMenu : [])



  return (
    <div className="flex flex-col w-full justify-start items-start font-rubik space-y-5">
      {headerMenu.map((menuItem) => {
        if (menuItem.dropdownButtons) {
        return (
            <Accordion key={menuItem.id} type="single" collapsible className="w-full p-0">
              <AccordionItem value="item-1" className="p-0">
                <AccordionTrigger className="text-gray-text text-base font-[500] px-5 py-0">{menuItem.buttonTitle}</AccordionTrigger>
                <AccordionContent className="pb-0 bg-[#f8f8f8]">
                  <div className="flex flex-col space-y-5 justify-center py-3 mt-2">
                    {menuItem.dropdownButtons.map((drop) =>
                      <Link key={drop.buttonTitle} href={`${drop.slug}`} className="text-gray-text font-[500] px-5">{drop.buttonTitle}</Link>
                    )}
                  </div>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          )
        } else {
          return (
            <Link className="text-gray-text font-[500] px-5" key={menuItem.id} href={`${menuItem.slug}`}>{menuItem.buttonTitle}</Link>
          )
        }
      })}
    </div>
  )
}